import { useCustomersStore } from '@/stores'
import { createPrefetchGuard } from '@/utils/routerGuards'

export default [
    {
        path: '/customers',
        name: 'customers',
        component: () => import('@/views/Customers/index.vue'),
        meta: {
            title: 'customers.pageTitle',
            menuRendered: true,
            menuTitle: 'customers.menuTitle',
            requiresAuth: true,
            permission: 'customers',
            icon: 'mdi-account-group'
        },
        redirect: { name: 'customersCustomers' },
        children: [
            {
                path: '/customers/customers',
                name: 'customersCustomers',
                component: () => import('@/views/Customers/Customers/index.vue'),
                meta: {
                    title: 'customers.pageTitle',
                    requiresAuth: true,
                    permission: 'customers_read'
                }
            },
            {
                path: '/customers/customers/create',
                name: 'customersCustomersCreate',
                component: () => import('@/views/Customers/Customers/Customer.vue'),
                beforeEnter: createPrefetchGuard({
                    getId: () => 'create',
                    fetch: async () => {
                        const customersStore = useCustomersStore()
                        await Promise.all([
                            customersStore.getCustomerTypes(),
                            customersStore.getCountries(),
                            customersStore.getAddressTypes(),
                            customersStore.getProductionFileCustomerConfiguration()
                        ])
                    },
                    onError: () => ({ name: 'customersCustomers' })
                }),
                meta: {
                    title: 'customers.createCustomerPageTitle',
                    requiresAuth: true,
                    permission: 'customers_create'
                }
            },
            {
                path: '/customers/customers/edit/:id',
                name: 'customersCustomersEdit',
                component: () => import('@/views/Customers/Customers/Customer.vue'),
                beforeEnter: createPrefetchGuard({
                    getId: (to) => to.params?.id,
                    fetch: async (id) => {
                        const customersStore = useCustomersStore()
                        await Promise.all([
                            customersStore.getCustomerTypes(),
                            customersStore.getCountries(),
                            customersStore.getAddressTypes(),
                            customersStore.getProductionFileCustomerConfiguration()
                        ])
                        await customersStore.fetchCustomerById(id)
                    },
                    onMissingId: () => ({ name: 'customersCustomers' }),
                    onError: () => ({ name: 'customersCustomers' })
                }),
                meta: {
                    title: 'customers.editCustomerPageTitle',
                    requiresAuth: true,
                    permission: 'customers_read'
                }
            }
        ]
    }
]
